import axios from "axios";
import { API } from "../../backend";
import authHeader from "../auth-header";
const getContract = (state) => {
  return axios.get(API + "contracts/contract-edit/" + state + "/", {
    headers: authHeader(),
  });
};
const editContract = (
  state,
  contract_number,
  contract_term,
  start_date,
  end_date,
  address_id,
  contract_type,
  deposit_amount,
  feesontime,
  tax_rate_rent,
  tax_rate_fee,
  customer_id,
  paymentrule,
  attribute,
  paymentfrequency,
  paymentstartdate,
  no_of_payments,
  Paymentend_date,
  amount,
  achPayments,
  achAccount,
  appOriginator,
  source,
  salesRep,
  subcompany,
  line_of_business
) => {
  return axios.post(
    API + "contracts/contract-edit/" + state + "/",
    {
      contract_number,
      contract_term,
      start_date,
      end_date,
      address_id,
      contract_type,
      deposit_amount,
      feesontime,
      tax_rate_rent,
      tax_rate_fee,
      customer_id,
      paymentrule,
      attribute,
      paymentfrequency,
      paymentstartdate,
      no_of_payments,
      Paymentend_date,
      amount,
      enable_ach: achPayments ? "Y" : "N",
      ach_account_id: achAccount || null,
      appOriginator,
      source,
      salesRep,
      subcompany,
      line_of_business,
    },
    { headers: authHeader() }
  );
};
const EditContractService = {
  getContract,
  editContract,
};
export default EditContractService;
